import { resolverTpagPagamento } from "@/modules/PdvDesktop/services/NfcePagamentoFiscalMapper";

const TPAG_MOVIMENTA_CAIXA = new Set(["01", "20"]);

/**
 * Dinheiro (01) e Pix (20) entram no movimento financeiro do caixa.
 * As demais formas de pagamento são tratadas como conta a receber no backend.
 */
export function pagamentoMovimentaCaixa(pagamento = {}) {
  const quantidadeParcelas = Math.max(
    Number(pagamento.vezes ?? pagamento.parcelas ?? 1) || 1,
    Array.isArray(pagamento.range) ? pagamento.range.length : 0
  );
  const descricao = String(pagamento.descricao ?? pagamento.description ?? "");
  if (
    quantidadeParcelas > 1 ||
    /a\s*prazo|credi[aá]rio|fiado/i.test(descricao)
  ) {
    return false;
  }

  return TPAG_MOVIMENTA_CAIXA.has(resolverTpagPagamento(pagamento));
}

export default pagamentoMovimentaCaixa;
